import { basePath } from 'src/env';

export const RoutePaths = {
    index: `${basePath}/`,

    loanApplications: `${basePath}/applications`,
    loanApplicationDetails: `${basePath}/applications/:id`,
    loanApplicationsCreate: `${basePath}/applications/create`,
};
